import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const addAssuranceZonePdpSelector = createSelector(testTargetOffersSelector, offers => offers.addAssuranceZonePdp || Empty.Object);

export { addAssuranceZonePdpSelector };
